module.exports = __webpack_public_path__ + "dc626c7491ed029ac5443db93d5d5b08.png";